import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";

import { HeroBand } from "@/components/shop/HeroBand";
import { useShopProfile } from "./shop";

export const Route = createFileRoute("/shop/")({
  component: ShopLanding,
});

function ShopLanding() {
  const profile = useShopProfile();

  // TNK-205 — operator-configurable title-block position (defaults center / top).
  const align = profile.landingTitleAlign ?? "center";
  const valign = profile.landingTitleValign ?? "top";
  const itemsClass =
    align === "left"
      ? "items-start text-left"
      : align === "right"
        ? "items-end text-right"
        : "items-center text-center";
  const justifyClass =
    valign === "center"
      ? "justify-center"
      : valign === "bottom"
        ? "justify-end"
        : "justify-start";
  const position = `${itemsClass} ${justifyClass}`;
  const buttonJustify =
    align === "left"
      ? "justify-start"
      : align === "right"
        ? "justify-end"
        : "justify-center";

  const titleBlock = (
    <div className="space-y-2">
      <h1 className="text-3xl font-bold text-foreground">
        {profile.storeName || "Card Store"}
      </h1>
      <p className="max-w-md text-sm text-muted-foreground">
        Browse available cards and reserve the ones you want. Reservations are
        requests — the seller confirms availability and follows up by email.
      </p>
    </div>
  );

  const browseButton = (
    <Link
      to="/shop/inventory"
      className="inline-flex items-center gap-2 rounded-md bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground hover:opacity-90"
    >
      Browse cards
      <ArrowRight className="h-4 w-4" />
    </Link>
  );

  // TNK-206 — optional hero band on the landing (operator toggle). When off, the
  // landing is its own plain page; when on, the configurable banner shows with
  // the title block positioned by the same align/valign config.
  // TNK-207 — with the hero on, the Browse button sits BELOW the band (aligned to
  // the same horizontal setting), rather than overlapping the banner art.
  if (profile.landingShowHero) {
    return (
      <>
        <HeroBand
          heroRef={profile.heroRef}
          heroHeight={profile.heroHeight}
          heroOpacity={profile.heroOpacity}
          heroFit={profile.heroFit}
          contentClassName={position}
        >
          {titleBlock}
        </HeroBand>
        <div className={`flex ${buttonJustify}`}>{browseButton}</div>
      </>
    );
  }

  return (
    <div className={`flex min-h-[70vh] flex-col gap-6 py-12 ${position}`}>
      {titleBlock}
      {browseButton}
    </div>
  );
}
